<template>
  <div class="allservice">
    <div class="searchBox">
      <el-input
        class="searchInput"
        size="small"
        v-model="productName"
        @keyup.native="changeProductInfo"
        placeholder="输入关键字"
        suffix-icon="el-icon-search"
      >
      </el-input>
    </div>
    <div class="serviceListMessage_box">
      <div
        class="serviceListMessage"
        v-for="(item, index) in serviceListMessageList"
        :key="index"
      >
        <div class="serviceListMessage_icon">
          {{ item.oneLabel }}/{{ item.twoLabel }}
        </div>
        <h3 @click="getServiceDetails(item.id)">{{ item.title }}</h3>
        <div class="flex-center-between service_money">
          <p class="service_money_box">
            ￥<span class="red">{{ item.money }}</span
            ><span class="unit">元</span>
          </p>
          <el-button size="small" type="primary" plain>立即询价</el-button>
        </div>
        <div class="flex-center-between">
          <p>
            <i class="el-icon-location-outline"></i>{{ item.addProvince }}·{{
              item.addCity
            }}·{{ item.addArea }}
          </p>
        </div>
      </div>
    </div>
    <div style="text-align: right">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange"
        @next-click="handleCurrentChange"
        layout="total,prev, pager, next,jumper"
        :current-page="current"
        :page-size="pageSize"
        :total="total"
        class="pagination"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      total: 0,
      current: 1,
      pageSize: 28,
      productName: "",
      serviceListMessageList: [
        {
          oneLabel: "水泵",
          twoLabel: "水泵",
          title: "车辆附件撒娇",
          money: "2222",
          addProvince: "北京市",
          addCity: "北京市",
          addArea: "北京市",
        },
         {
          oneLabel: "水泵",
          twoLabel: "水泵",
          title: "车辆附件撒娇",
          money: "2222",
          addProvince: "北京市",
          addCity: "北京市",
          addArea: "北京市",
        },
         {
          oneLabel: "水泵",
          twoLabel: "水泵",
          title: "车辆附件撒娇",
          money: "2222",
          addProvince: "北京市",
          addCity: "北京市",
          addArea: "北京市",
        },
         {
          oneLabel: "水泵",
          twoLabel: "水泵",
          title: "车辆附件撒娇",
          money: "2222",
          addProvince: "北京市",
          addCity: "北京市",
          addArea: "北京市",
        },
         {
          oneLabel: "水泵",
          twoLabel: "水泵",
          title: "车辆附件撒娇",
          money: "2222",
          addProvince: "北京市",
          addCity: "北京市",
          addArea: "北京市",
        },
      ],
    };
  },
  methods: {
    changeProductInfo() {
      this.current = 1;
      // this.getShopList();
    },
    // 分页
    handleCurrentChange(val) {
      this.current = val;
      window.scrollTo(0, 0);
      // this.getShopList()
    },
    getServiceDetails(id) {
      let routeData = this.$router.resolve({
        path: `/serviceDetails`,
        query: { uuid: id },
      });
      window.open(routeData.href, "_blank");
      // this.$router.push({name:"serviceDetails",params:{uuid:id}});
    },
  },
};
</script>

<style lang="less" scoped>
.allservice {
  margin-top: 30px;
  .searchBox {
    background-color: #fafcff;
    height: 50px;
    line-height: 50px;
    margin: 30px 0 15px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 20px;
    .searchInput {
      width: 20%;
    }
    .searchInput /deep/ .el-input__inner {
      border-radius: 30px;
    }

    /deep/ .el-form-item {
      margin-bottom: 0;
    }

    /deep/ .el-form-item__label {
      line-height: inherit;
    }

    /deep/ .el-form-item__content {
      line-height: inherit;
    }

    .el-cascader /deep/ .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
  .serviceListMessage_box {
    display: grid;
    grid-template-columns: 33% 33% 33%;
    grid-column-gap: 8px;
    margin-bottom: 40px;
  }
  .serviceListMessage {
    margin-top: 10px;
    background: #fff;
    padding: 20px;
    .serviceListMessage_icon {
      color: #009999;
      font-size: 12px;
      line-height: 10px;
      margin-bottom: 10px;
    }
    h3 {
      font-size: 20px;
      cursor: pointer;
    }
    p {
      font-size: 14px;
      color: #6e6e6e;
      i {
        margin-right: 5px;
      }
    }
    .flex-center-between {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .service_money {
      margin-top: 10px;
      padding-bottom: 15px;
      border-bottom: 1px dotted #cecece;
      margin-bottom: 20px;

      button {
        width: 92px;
      }
      .service_money_box {
        font-size: 12px;
        color: #ff3b30;
        .red {
          font-weight: bold;
          font-size: 16px;
          margin: 0 5px;
        }
        .unit {
          color: #6e6e6e;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/print/allService.vue